var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 9.66665H23.1667C23.9031 9.66665 24.5 10.2636 24.5 11V27C24.5 27.7364 23.9031 28.3333 23.1667 28.3333H1.83333C1.09696 28.3333 0.5 27.7364 0.5 27V11C0.5 10.2636 1.09696 9.66665 1.83333 9.66665H4.5V8.33331C4.5 3.91503 8.08172 0.333313 12.5 0.333313C16.9183 0.333313 20.5 3.91503 20.5 8.33331V9.66665ZM3.16667 12.3333V25.6666H21.8333V12.3333H3.16667ZM11.1667 17.6666H13.8333V20.3333H11.1667V17.6666ZM5.83333 17.6666H8.5V20.3333H5.83333V17.6666ZM16.5 17.6666H19.1667V20.3333H16.5V17.6666ZM17.8333 9.66665V8.33331C17.8333 5.38779 15.4455 2.99998 12.5 2.99998C9.55448 2.99998 7.16667 5.38779 7.16667 8.33331V9.66665H17.8333Z",
    fill: "#ED1002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockFill);
export default __webpack_public_path__ + "static/media/lock-fill.42282463f420d11826c6566acccdb093.svg";
export { ForwardRef as ReactComponent };